import { useState, useEffect } from "react";
import Api from "lib/api";
import { mapTruckByIdToUi } from "../mapOptionsT0Ui";
import { mapObjectionsToUi } from "modules/shared/profiles/mapObjectionsToUi";

const useFetchTruck = (truckId, included) => {
    const [selectedTruckData, setSelectedTruckData] = useState(null);
    const [truckAttachments, setTruckAttachments] = useState(null);
    const [objections, setObjections] = useState({});

    const getTruckById = async () => {
        try {
            const response = await Api.get(`/trucks/${truckId}`, {
                params: {
                    include: `${included}`,
                },
            });
            const includedData = response?.included;
            const truckData = response?.data?.attributes;
            const truckTypeData = response?.included[0];
            const suppliersData = response?.included?.filter((item) => item?.type === "suppliers");
            let attachments = [];
            attachments = response.included?.map((item) => {
                if (item?.type === "attachments") {
                    return { ...item?.attributes, id: item?.id };
                }
            });
            setTruckAttachments(attachments);
            setSelectedTruckData(mapTruckByIdToUi(truckData, suppliersData, truckTypeData));
            setObjections(mapObjectionsToUi(includedData));
        } catch (error) {
            return error;
        }
    };
    useEffect(() => {
        getTruckById();
    }, [truckId]);
    return {
        selectedTruckData,
        truckAttachments,
        setTruckAttachments,
        objections,
    };
};

export default useFetchTruck;
